import React from 'react';
import s from './SecureCheckout.scss';
import {classes} from './SecureCheckout.st.css';
import Lock from '../../../assets/images/Lock.svg';
import classNames from 'clsx';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';

export enum SecureCheckoutDataHook {
  lock = 'SecureCheckoutDataHook.lock',
  text = 'SecureCheckoutDataHook.text',
  root = 'SecureCheckoutDataHook.root',
}
export const SECURE_CHECKOUT_ID = 'secure-checkout-id';

export const SecureCheckout = ({text, className}: {text: string; className?: string}) => {
  const {fixSecureCheckoutBadgeColor} = useControllerProps().cartStore;

  return (
    <p
      id={SECURE_CHECKOUT_ID}
      className={classNames(s.secureCheckout, classes.secureCheckout, className)}
      data-hook={SecureCheckoutDataHook.root}>
      <Lock
        className={
          fixSecureCheckoutBadgeColor ? s.secureCheckoutLock : /* istanbul ignore next */ s.secureCheckoutLockOld
        }
        data-hook={SecureCheckoutDataHook.lock}
      />
      <span
        className={
          fixSecureCheckoutBadgeColor ? s.secureCheckoutText : /* istanbul ignore next */ s.secureCheckoutTextOld
        }
        data-hook={SecureCheckoutDataHook.text}>
        {text}
      </span>
    </p>
  );
};
